<template>
  <div class="stageContainer">
    <b-modal id="nextStage_1_prev" :title="title" centered @ok="onPrevStage" ok-title="확인" cancel-title="취소">
      <div class="bg-white p-3 rounded box-shadow">
        <p class="text-muted mb-0">
          지금까지 작성한 예약정보가 사라집니다.<br />
          계속 진행하시겠습니까?
        </p>
      </div>
    </b-modal>
    <ReceiptDetail :list-type="listType" :rev-confirm-list="revConfirmList" />
    <div class="buttonGroup">
      <button class="moveButton" @click="prevStage()">
        <span>이전</span>
      </button>
      <button class="moveButton" @click="nextStage()">
        <span>다음</span>
      </button>
    </div>

    <!--      <b-button class="col-2 p-3 mx-1" @click="prevStage()" variant="danger">이전</b-button>-->
    <!--      <b-button class="col-2 p-3 mx-1" @click="nextStage()" variant="primary">다음</b-button>-->
  </div>
</template>

<script>
import ReceiptDetail from '@/pages/RevReceiptPage/Component/ReceiptDetail';
import GeneralUtil from '@/util/GeneralUtil';
export default {
  name: 'RegStage2',
  mixins: [GeneralUtil],
  components: {ReceiptDetail},
  props: {
    listType: String,
    revConfirmList: Array,
  },
  data() {
    return {
      title: '',
    };
  },
  computed: {
    isCompany() {
      let user = this.$store.getters['Auth/selectedMember'];
      // 법인회원 코드 : 006
      return user.memType === '006';
    },
  },
  methods: {
    onPrevStage() {
      this.$EventBus.$emit('PrevStage');
    },
    hasFinishContacts() {
      let result = true;
      this.revConfirmList.forEach(x => {
        // 연락처 기재 유무 체크
        result &= x.receiptDetail.isCompletedContact(this.isCompany);
      });
      return result;
    },
    hasFinishNames() {
      let result = true;
      this.revConfirmList.forEach(x => {
        // 연락처 기재 유무 체크
        result &= x.receiptDetail.isCompletedName(this.isCompany);
      });
      return result;
    },

    hasFinish2() {
      let result = true;
      this.revConfirmList.forEach(x => {
        // 최소인원 2명 체크
        result &= x.receiptDetail.isCompletedMember();
      });

      return result;
    },

    hasFinishRentClubs() {
      let result = true;
      this.revConfirmList.forEach(x => {
        // 골프 클럽 최대 대여개수는 사람 수만큼
        let peopleCount = x.receiptDetail.teamManCnt + x.receiptDetail.teamWomanCnt;

        let totalClubCount = 0;
        x.receiptDetail._rentListClub.forEach(x => {
          totalClubCount += x.saleQty;
        });
        let flag = totalClubCount <= peopleCount;
        result = result && flag;
      });

      return result;
    },

    hasFinishRentShoes() {
      let result = true;
      this.revConfirmList.forEach(x => {
        // 골프 클럽 최대 대여개수는 사람 수만큼
        let peopleCount = x.receiptDetail.teamManCnt + x.receiptDetail.teamWomanCnt;

        let totalClubCount = 0;
        x.receiptDetail._rentListShoes.forEach(x => {
          totalClubCount += x.saleQty;
        });
        let flag = totalClubCount <= peopleCount;
        result = result && flag;
      });

      return result;
    },

    nextStage() {
      // let flag1 = this.hasFinishContacts();
      // let flag2 = this.hasFinish2();
      // let flag3 = this.hasFinishNames();
      //
      // console.log('체크', flag1, flag2, flag3);

      // if (!this.hasFinish2() || !this.hasFinishRentClubs() || !this.hasFinishRentShoes() || !this.hasFinish()) {
      //   this.showMsgBoxOk('필수 정보 확인 부탁 드립니다.');
      //   return;
      // }
      //
      if (!this.hasFinishNames()) {
        this.showMsgBoxOk(`필수 정보 확인 부탁 드립니다.`, '이용자 입력');
        return;
      }
      if (!this.hasFinishContacts()) {
        this.showMsgBoxOk(`필수 정보 확인 부탁 드립니다.`, '연락처');
        return;
      }
      if (!this.hasFinish2()) {
        this.showMsgBoxOk(`필수 정보 확인 부탁 드립니다.`, '최소 인원수 입력');
        return;
      }

      if (!this.hasFinishRentClubs()) {
        this.showMsgBoxOk(`대여채 수량 확인 부탁 드립니다.`, '대여채 정보 확인');
        return;
      }

      if (!this.hasFinishRentShoes()) {
        this.showMsgBoxOk(`대여화 수량 확인 부탁 드립니다.`, '대여화 정보 확인');
        return;
      }

      const messageForCompany = `
        다음으로 넘어가시겠습니까?<br /><div style="font-size: 0.8rem; color: #3e51f3; margin-top: 1rem; font-weight: bold">※ 여러 건의 예약을 한 번에 접수하실 경우, 하나의 예약 번호로 통합 처리됩니다.<br/><span style="visibility:hidden;">※ </span>정확한 예약 관리를 위해 예약은 내장자별로 접수해 주시기 바랍니다.<br/><span style="visibility:hidden;">※ </span>예약 번호가 하나로 묶이면 확정 / 취소 시 전체 예약이 함께 처리될 수 있습니다.<br/><span style="visibility:hidden;">※ </span><span style="color: #555" class="font-weight-bold">단, 본인/배우자 2팀 내장하는 경우에는 본인 내장으로 접수해 주시기 바랍니다.</span><br/><br/><span style="color: #555; font-weight: normal">※ 대여화 사이즈 기입, SMS 수신 여부 체크 등 확인 부탁드립니다.</span></div>
      `;

      const messageForNormal = `
        다음으로 넘어가시겠습니까?<br /><div style="font-size: 0.8rem; color: #555555; margin-top: 1rem">※ 대여화 사이즈 기입, SMS 수신 여부 체크 등 확인 부탁드립니다.</div>
      `;

      const html = this.isCompany ? messageForCompany : messageForNormal;

      this.showMsgBoxConfirm(this.htmlToVNode(html)).then(value => {
        if (value === true) {
          this.$EventBus.$emit('NextStage');
        }
      });

      // if (this.hasFinish()) {
      //   this.$EventBus.$emit('NextStage');
      // } else {
      //   this.showDialog('필수정보 입력', `필수 접수정보를 입력하세요.`);
      // }
    },

    prevStage() {
      this.title = '이전상태 이동';
      this.$bvModal.show('nextStage_1_prev');
    },
  },
};
</script>

<style scoped lang="scss">
.buttonGroup {
  display: flex;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1rem;
  width: 30%;
  .moveButton {
    display: inline-flex;
    align-items: center;
    height: 2.3rem;
    font-size: 0.8rem;
    width: 100%;
    margin: 1rem;

    background-color: #524a3d !important;
    padding: 0px !important;
    color: white;
    border: none;
    outline: none;
    span {
      padding: 0px;
      width: 100%;
      text-align: center;
      padding: 0px !important;
    }
    &:hover {
      background-color: #403a30 !important;
    }
  }
}
@media (min-width: 992px) {
  .stageContainer {
    width: 100%;
    //padding-left: 5%;
    //padding-right: 5%;
  }
}
@media (max-width: 992px) {
  .stageContainer {
    width: 100%;
  }
  .buttonGroup {
    display: flex;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 1rem;
    width: 100%;
    .moveButton {
      display: inline-flex;
      align-items: center;
      height: 2.3rem;
      font-size: 0.8rem;
      width: 100%;
      margin: 1rem;

      background-color: #524a3d !important;
      padding: 0px !important;
      color: white;
      border: none;
      outline: none;
      span {
        padding: 0px;
        width: 100%;
        text-align: center;
        padding: 0px !important;
      }
      &:hover {
        background-color: #403a30 !important;
      }
    }
  }
}
</style>
